import {createFileRoute} from '@tanstack/react-router';

import ImagePage from '~components/common/ImagePage';
import {ModelProvider} from 'src/contexts/ModelProvider';

export const Route = createFileRoute('/archive/image')({
  component: ArchiveImagePage,
});

function ArchiveImagePage() {
  return (
    <ModelProvider mode='archive-annotator'>
      <ImagePage mode='archive' />
    </ModelProvider>
  );
}
